<template>
  <div>
    <FundLetters />
    <FundReports />
    <AddDocumentModal @save-document="handleSaveDocument" />
  </div>
</template>

<script>
import FundLetters from './FundLetters.vue'; 
import FundReports from './FundReports.vue';
import AddDocumentModal from './AddDocumentModal.vue';

export default {
  name: 'FundsHub',
  components: {
    FundLetters,
    FundReports,
    AddDocumentModal,
  },
  methods: {
    handleSaveDocument(newDoc) {
      console.log("Novo documento recebido:", newDoc);
    },
  },
};
</script>
